import { render, staticRenderFns } from "./DeleteSmsMessageForm.vue?vue&type=template&id=61010b99"
import script from "./DeleteSmsMessageForm.vue?vue&type=script&lang=js"
export * from "./DeleteSmsMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports